/**
 * @generated SignedSource<<54d1fd17d516779d8f4b6c9915e0ae9e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderInlineDataFragment } from 'relay-runtime';
export type IssueFieldDataType = "DATE" | "NUMBER" | "SINGLE_SELECT" | "TEXT" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type IssueFieldPickerIssueField$data = {
  readonly dataType?: IssueFieldDataType;
  readonly databaseId?: number | null | undefined;
  readonly id?: string;
  readonly name?: string;
  readonly " $fragmentType": "IssueFieldPickerIssueField";
};
export type IssueFieldPickerIssueField$key = {
  readonly " $data"?: IssueFieldPickerIssueField$data;
  readonly " $fragmentSpreads": FragmentRefs<"IssueFieldPickerIssueField">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "IssueFieldPickerIssueField"
};

(node as any).hash = "a3c6ea26fe6fdccd7eaccbc318920a2b";

export default node;
